import { FILTER_MAP } from '@domain/style';
import { getBoundingRectangleOfRotatedBox, getOuterBounds } from '@studio/utils/geom';
import { isGroupDataNode, toFlatElementNodeList } from '../nodes/helpers';
import { getBoundingBoxOfElementWithState } from '../rendering';
export function calculateBoundingBox(nodes, state) {
    const boxes = nodes
        .map(node => {
        if (isGroupDataNode(node)) {
            return toFlatElementNodeList(node);
        }
        return node;
    })
        .flat()
        .map((node, _, array) => {
        if (array.length === 1) {
            return getBoundingBoxOfElementWithState(node, state, true);
        }
        // Multiple elements selected, include rotations in box size.
        return getBoundingRectangleOfRotatedBox(node);
    });
    return Object.assign({ rotationZ: 0 }, (boxes.length === 1 ? boxes[0] : getOuterBounds(...boxes)));
}
/**
 * Converts the `filter` object to a string.
 * @returns A string that can be used as a CSS value.
 */
export function getFilterString(filters) {
    const values = Object.entries(filters)
        .filter(([_, filter]) => (filter === null || filter === void 0 ? void 0 : filter.value) !== undefined)
        .map(([key, filter]) => {
        var _a;
        const filterUnit = (_a = FILTER_MAP[key]) === null || _a === void 0 ? void 0 : _a.unit;
        return `${key}(${filter.value.toFixed(0)}${filterUnit})`;
    });
    return values.join(' ');
}
